import { createStore, applyMiddleware, combineReducers, compose, Middleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { isDev } from '@chat/utils';
import IndexReducer from './index/reducer';
import FaqReducer from './faq/reducer';
import IMReducer from './im/reducer';

/** 开发环境，开启redux-devtools */
const composeEnhancers =
    (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const logger = createLogger({
    predicate: (getState, action) => {
        if (action.payload) {
            return action.payload.type !== 'WAITING_QUEUE' && action.type !== 'SET_LAST';
        }
        return action.type !== 'SET_MESSAGE_COUNT';
    },
    level: {
        prevState: false,
        action: 'info',
        nextState: false,
        error: 'error'
    },
    diff: false
});
const middlewares: Middleware[] = [thunk];
if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger);
}
const reducers = combineReducers({
    IndexReducer,
    FaqReducer,
    IMReducer
});
const store = isDev
    ? createStore(reducers, composeEnhancers(applyMiddleware(...middlewares)))
    : createStore(reducers, applyMiddleware(...middlewares));
export type AppState = ReturnType<typeof reducers>;
export default store;
